import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import { fr } from './fr';
import { en } from './en';
i18n
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
    fallbackLng: 'fr',
    supportedLngs: ['fr', 'en'],
    interpolation: { escapeValue: false },
    resources: {
        fr: { translation: fr },
        en: { translation: en },
    },
    detection: {
        order: ['localStorage', 'navigator'],
        lookupLocalStorage: 'civille:lang',
        caches: ['localStorage'],
    },
});
export default i18n;
//# sourceMappingURL=i18n.js.map